module.exports = __webpack_public_path__ + "media/smooth-scroller.1045f7e2.mp4";